import {
  ContactMethodChannel,
  ListingStructureType,
  OpportunityCancellationType,
  TradeIntentStatusType,
  TradeIntentType,
} from 'graphql/bindings/AdminBindings'

import { opportunityCancellationTypeDisplayName, opportunityStatusDisplayName } from './OpportunityUtils'

export const sensitivityOpts = [
  { label: 'Low', value: 'low' },
  { label: 'Medium', value: 'medium' },
  { label: 'High', value: 'high' },
]

export const campaignTypes = [
  { label: 'Email', value: 'email' },
  { label: 'Offering', value: 'offering' },
]

export const campaignFilterOptions = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Closed', value: 'closed' },
]

export const relationshipStrengthOpts = [
  { label: 'Weak', value: 'weak' },
  { label: 'Medium', value: 'medium' },
  { label: 'Strong', value: 'strong' },
]

export const aumOptions = [
  { label: '$0-$25M', value: '<25m' },
  { label: '$25M-$100M', value: '25m-100m' },
  { label: '$100M-$500M', value: '100m-500m' },
  { label: '$500M-$1B', value: '500m-1b' },
  { label: '$1B-$10B', value: '1b-10b' },
  { label: '$10B+', value: '10b+' },
]

export const aumDedicated = ['0-10%', '10-25%', '25-50%', '50-75%', '75-100%']

export const offeringTypes = [
  { label: 'FCS Primary', value: 'fcs_primary' },
  { label: 'FCS Secondary', value: 'fcs_secondary' },
  { label: 'Sealed Bid Second Highest Price Auction', value: 'sealed_bid_second_highest_price_auction' },
  { label: 'Open Bid Auction', value: 'open_bid_auction' },
  { label: 'First Come First Fill Offering', value: 'first_come_first_fill_auction' },
]

export const netWorth = [
  { label: '<$1M', value: '<1m' },
  { label: '$1-2M', value: '1m-2m' },
  { label: '$2-5M', value: '2m-5m' },
  { label: '$5-10M', value: '5m-10m' },
  { label: '$10-25M', value: '10m-25m' },
  { label: '$25-100M', value: '25m-100m' },
  { label: '$100M+', value: '100m+' },
]

export const targetCheckSize = [
  { label: '<$50K', value: '<50k' },
  { label: '$50K-$100K', value: '50k-100k' },
  { label: '$100K-$500K', value: '100k-500k' },
  { label: '$500K-$2M', value: '500k-2M' },
  { label: '$2M-$5M', value: '2M-5M' },
  { label: '$5M-$10M', value: '5M-10M' },
  { label: '$10M-25M+', value: '10M-25M' },
  { label: '$25M+', value: '25M+' },
]

export const orderAssetTypeOptions = [
  { label: 'Common', value: 'common_stock' },
  { label: 'Preferred', value: 'preferred_stock' },
  { label: 'Foreign LP Units', value: 'foreign_lp_units' },
  { label: 'Fund Units', value: 'equifund_units' },
]

export const sourceOptions = [
  { label: 'Team', value: 'manual_client' },
  { label: 'Platform', value: 'platform' },
  { label: 'System generated', value: 'system_generated' },
]

export const regions = [
  'North America',
  'Central America and Caribbean',
  'East Asia',
  'Europe',
  'Central Asia',
  'Oceania',
  'South Asia',
  'South America',
  'Middle East and North Africa',
  'Sub-Saharan Africa',
]

export const opportunities = [
  { label: 'LP Interests', value: 'Limited Partnership Interests' },
  { label: 'Primaries', value: 'Primaries' },
  { label: 'Secondaries', value: 'Secondaries' },
  { label: 'Synthetics', value: 'Synthetics' },
]

export const InvestorStructureAbility = [
  {
    label: 'Forwards, SPVs, and Direct',
    value: ['forward_backed_fund_interest', 'share_backed_fund_interest', 'direct_share_transfer'],
  },
  {
    label: 'SPVs and Direct',
    value: ['share_backed_fund_interest', 'direct_share_transfer'],
  },
  { label: 'Direct Only', value: ['direct_share_transfer'] },
  { label: 'SPV Only', value: ['share_backed_fund_interest'] },
]

export const CompanyStateOpts = [
  { label: 'Early', value: 'early' },
  { label: 'Mid', value: 'mid' },
  { label: 'Late', value: 'late' },
]

export const BooleanSwitch = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

export const ContactOptions = [
  { label: 'OK to contact', value: 'unrestricted' },
  { label: "Don't contact", value: 'do_not_contact' },
  { label: 'Contact through intermediary', value: 'contact_through_intermediary' },
]
export const InvestorShareholderOpts = [
  { label: 'Investor', value: 'Investor' },
  { label: 'Shareholder', value: 'Shareholder' },
]

export const assetTypeOptions = [
  { label: 'Common', value: 'common_stock' },
  { label: 'Preferred', value: 'preferred_stock' },
  { label: 'RSU', value: 'restricted_stock_units' },
  { label: 'Options', value: 'options' },
  { label: 'Fund Units', value: 'equifund_units' },
  { label: 'Other', value: 'other' },
]

export const opportunityCertainty = [
  { label: 'Idea', value: 'theory' },
  { label: 'Soft', value: 'soft' },
  { label: 'Serious', value: 'serious' },
  { label: 'Firm', value: 'firm' },
]

export const opportunityStatusOpts = [
  { label: 'Pipeline', value: 'pipeline' },
  { label: 'Qualified', value: 'qualified' },
  { label: 'Pre-closing', value: 'pre_closings' },
  { label: 'Closings', value: 'closings' },
  { label: 'Settlement', value: 'settlement' },
  { label: 'Closed', value: 'closed' },
]

export const dealBlockerOpts = [
  { label: 'No indication of intent to sell', value: 'No indication of intent to sell' },
  { label: 'No matching price', value: 'No matching price' },
  { label: 'Low ROI transaction', value: 'Low ROI transaction' },
  { label: 'Issuer market event', value: 'Issuer market event' },
  { label: 'Market price unknown', value: 'Market price unknown' },
  { label: 'No compatible structure available', value: 'No compatible structure available' },
  { label: 'No compatible timing', value: 'No compatible timing' },
  { label: 'No compatiable transfer restrictions', value: 'No compatiable transfer restrictions' },
  { label: 'Account too unreliable to match', value: 'Account too unreliable to match' },
  { label: 'Wrong domicile (tax jurisdiction)', value: 'Wrong domicile (tax jurisdiction)' },
  { label: 'Needs information', value: 'Needs information' },
  { label: 'Needs management conversation', value: 'Needs management conversation' },
  { label: 'Bullish holder (not a seller)', value: 'Bullish holder (not a seller)' },
  { label: 'Bearish (not a buyer)', value: 'Bearish (not a buyer)' },
  { label: 'Client unresponsive', value: 'Client unresponsive' },
  { label: 'Counterparty unresponsive', value: 'Counterparty unresponsive' },
  { label: 'Stale', value: 'Stale' },
]

export const contactMethods = [
  { value: 'phone_call', label: 'Phone call' },
  { value: 'in_person', label: 'In-person' },
  { value: 'messaging', label: 'Other' },
  { value: 'note', label: 'Note' },
]

export const contactMethodChannels = [
  { value: ContactMethodChannel.Email, label: 'Email' },
  { value: ContactMethodChannel.Phone, label: 'Phone' },
  { value: ContactMethodChannel.Linkedin, label: 'LinkedIn' },
  { value: ContactMethodChannel.Wechat, label: 'WeChat' },
  { value: ContactMethodChannel.Whatsapp, label: 'Whatsapp' },
]

export const bidOrAskStructures = (opportunityType: TradeIntentType) => {
  switch (opportunityType) {
    case TradeIntentType.Ask:
      return askStructures
    case TradeIntentType.Bid:
      return bidStructures
  }
}

export const askStructures = [
  {
    label: 'Direct',
    value: [ListingStructureType.DirectShareTransfer],
  },
  {
    label: 'SPV',
    value: [ListingStructureType.ShareBackedFundInterest],
  },
  { label: 'Forward', value: [ListingStructureType.ForwardBackedFundInterest] },
]

export const bidStructures = [
  {
    label: 'Forwards, SPVs, and Direct',
    value: [
      ListingStructureType.ForwardBackedFundInterest,
      ListingStructureType.ShareBackedFundInterest,
      ListingStructureType.DirectShareTransfer,
    ],
  },
  {
    label: 'SPVs and Direct',
    value: [ListingStructureType.ShareBackedFundInterest, ListingStructureType.DirectShareTransfer],
  },
  { label: 'Direct Only', value: [ListingStructureType.DirectShareTransfer] },
]

export const statusOptions = [
  TradeIntentStatusType.PrePipeline,
  TradeIntentStatusType.Pipeline,
  TradeIntentStatusType.Qualified,
  TradeIntentStatusType.PreClosings,
  TradeIntentStatusType.Closings,
  TradeIntentStatusType.Settlement,
].map(status => ({ label: opportunityStatusDisplayName(status), value: status }))

export const opportunityCancellationTypeOptions = Object.values(OpportunityCancellationType).map(value => ({
  label: opportunityCancellationTypeDisplayName(value),
  value,
}))

type SelectOption = {
  label: string
  value: string
}

export const cancellationReasonOptions: {
  [K in OpportunityCancellationType]?: SelectOption[]
} = {
  [OpportunityCancellationType.LostToCompetitor]: [
    { label: 'Better Price', value: 'better_price' },
    { label: 'Faster Execution', value: 'faster_execution' },
    { label: 'Closer Relationship', value: 'closer_relationship' },
    { label: 'Better Structure', value: 'better_structure' },
  ],
  [OpportunityCancellationType.FellThrough]: [
    { label: 'Price', value: 'price' },
    { label: 'Size', value: 'size' },
    { label: 'Structure', value: 'structure' },
    { label: 'Issuer', value: 'issuer' },
  ],
}

export const competitorOptions: SelectOption[] = [
  { label: 'Sharespost', value: 'sharespost' },
  { label: 'Equityzen', value: 'equityzen' },
  { label: 'NASDAQ Private Market', value: 'nasdaq_private_market' },
  { label: 'Carta', value: 'carta' },
  { label: 'Other Broker', value: 'other_broker' },
  { label: 'Other', value: 'other' },
]

export enum OutreachOptions {
  TwoWeeks,
  OneWeek,
  Custom,
  Never,
}

export const outreachOptionsDropdown = [
  { label: '7 Days', value: OutreachOptions.OneWeek },
  { label: '14 Days', value: OutreachOptions.TwoWeeks },
  { label: 'Custom', value: OutreachOptions.Custom },
  { label: "Don't remind me", value: OutreachOptions.Never },
]

export const accountTypeOptions = [
  { label: 'Individual', value: 'individual' },
  { label: 'Organization', value: 'organization' },
]
